var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "site-link",
    {
      staticClass: "card horizontal inverted with-top-tag margin-bottom-0",
      staticStyle: { "max-height": "var(--spacing-8xl)", overflow: "hidden" },
      attrs: { to: _vm.$search({ iconCollections: ["brands"] }) },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "section text-left margin-top-0 padding-top-0 padding-bottom-2xs",
          staticStyle: { "max-width": "14rem" },
        },
        [
          _c(
            "h4",
            {
              staticClass: "text-uppercase size-md",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "700",
              },
            },
            [_vm._v("\n      Brands\n    ")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "margin-0 size-sm",
              staticStyle: { "font-weight": "400" },
            },
            [
              _vm._v(
                "\n      The easiest way to add social logos to your site.\n    "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header padding-bottom-sm",
          staticStyle: {
            "clip-path": "polygon(0% 0, 100% 0%, 1000% 100%, 30px 100%)",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-top": "-3.5rem" } },
            _vm._l(
              [_vm.cardIconsRowOne, _vm.cardIconsRowTwo, _vm.cardIconsRowThree],
              function (iconRow, rowIndex) {
                return _c(
                  "div",
                  {
                    key: rowIndex,
                    staticClass:
                      "size-xl display-flex flex-content-around margin-y-md",
                  },
                  _vm._l(iconRow, function (icon, iconIndex) {
                    return _c(
                      "span",
                      { key: iconIndex },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.getIconString("brands", icon) },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              }
            ),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }